import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

function list(params) {
  return request({
    url: ENDPOINT.ACCOUNTS,
    method: "get",
    params,
  });
}

function create(data) {
  return request({
    url: ENDPOINT.ROLE_ACCOUNT,
    method: "post",
    data,
  });
}

function update(data) {
  return request({
    url: `${ENDPOINT.ACCOUNTS}/${data.id}`,
    method: "patch",
    data,
  });
}

export default {
  list,
  create,
  update,
};
